<template>
  <div>
    <!--
    <b-row>
      <b-col>
        <h5 class="text-secondary float-right">{{ $t("globals.amount") }}:</h5>
      </b-col>
      <b-col>
        <icon v-if="loading" name="spinner" spin></icon>
        <span v-else class="text-success" >{{ currencyFormat(value) }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5 class="text-secondary float-right">{{ $t("globals.credit") }}:</h5>
      </b-col>
      <b-col>
        <icon v-if="loading" name="spinner" spin></icon>
        <span v-else class="text-danger" >{{ currencyFormat(credit_value * -1) }}</span>
      </b-col>
    </b-row>
    -->
    <b-row>
      <b-col>
        <h5 class="text-secondary float-right">{{ $t("globals.sum") }}:</h5>
      </b-col>
      <b-col>
        <icon v-if="loading" name="spinner" spin></icon>
        <span v-else class="text-info">
          {{ currencyFormat(value + credit_value) }}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ulu-date-picker
          range
          :not-after="Date.now()"
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.select_range')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import { currencyFormat } from "@/helpers/price";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      range: [null, null],
      value: 0,
      credit_value: 0,
      loading: false
    };
  },
  methods: {
    ...mapActions(["fetchPastRevenue"]),
    currencyFormat,
    fetchData(range) {
      this.loading = true;

      this.fetchPastRevenue(range)
        .then(res => {
          this.value = res.data.data.pastRevenue[0];
          this.credit_value = res.data.data.pastRevenue[1];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clean() {
      this.value = 0;
      this.credit_value = 0;
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"])
  },
  watch: {
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        const range = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];

        this.fetchData(range);
      } else {
        this.clean();
      }
    },
    getUserSystem: function() {
      this.range = [null, null];
      this.clean();
    }
  }
};
</script>
